<div class="app-bookmarks-dialog">
  <div class="header">
    <button mat-icon-button class="back-button" (click)="close()">
      <mat-icon>arrow_back</mat-icon>
    </button>
    <h3>Hours</h3>
    <button mat-icon-button class="close-button" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="content">
    <div class="hours-container">
      <div class="hour-item" *ngFor="let day of daysOfWeek">
        <div class="hour-day">
          <span>{{ WEEKDAYS[day] }}</span>
        </div>
        <div class="hour-right">
          <div class="hour-times">
            @if (hours.open24Hours) {
              <div class="hour-time" *ngIf="hours.open24Hours">
                <span>Open 24 hours</span>
              </div>
            } @else {
              <div class="hour-time" *ngFor="let hour of hours.dayHours[day]">
                @if (hour.open && hour.close) {
                  <span>{{ formatTime(hour.open) }}</span>
                  <span>—</span>
                  <span>{{ formatTime(hour.close) }}</span>
                } @else {
                  <span>Closed</span>
                }
              </div>
            }
          </div>
          <button mat-icon-button class="edit-button" (click)="openEditHourDialog([day])">
            <mat-icon>edit</mat-icon>
          </button>
        </div>
      </div>

      <div class="hour-change-buttons">
        <button mat-stroked-button (click)="openEditHourDialog(daysOfWeek)">
          Edit all hours
        </button>
        <button mat-stroked-button (click)="openEditHourDialog(daysOfWeek.slice(1, 6))">
          Edit Mon-Fri
        </button>
        <button mat-stroked-button (click)="openEditHourDialog(['SAT', 'SUN'])">
          Edit Sat-Sun
        </button>
      </div>
    </div>

    <div class="action-buttons">
      <button mat-button type="button" (click)="close()">Cancel</button>
      <button mat-flat-button color="primary" (click)="save()">Save</button>
    </div>
  </div>
</div>
